document.documentElement.classList.remove('no-js');
const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
const money=(cents)=>new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR'}).format((cents||0)/100);
function toast(msg){const el=$('[data-toast]');if(!el)return;el.textContent=msg;el.classList.add('is-visible');setTimeout(()=>el.classList.remove('is-visible'),1800)}
async function getCart(){return fetch('/cart.js').then(r=>r.json())}
function updateCount(n){$$('[data-cart-count]').forEach(x=>x.textContent=n)}
async function renderDrawer(){
  const cart=await getCart(); updateCount(cart.item_count);
  const body=$('[data-cart-drawer-body]'), subtotal=$('[data-cart-subtotal]'), progress=$('[data-shipping-progress]'), msg=$('[data-shipping-message]');
  if(!body)return;
  if(!cart.items.length){body.innerHTML='<p>Il carrello è vuoto.</p>'; subtotal.textContent=money(0); if(progress)progress.style.width='0%'; if(msg)msg.textContent='Aggiungi i tuoi prodotti preferiti.'; return}
  body.innerHTML=cart.items.map((i,idx)=>`<div class="ps-drawer-item"><img src="${i.image||''}" alt=""><div><strong>${i.product_title}</strong><br><small>${i.variant_title||''}</small><br><button class="ps-add" data-remove-line="${idx+1}">Rimuovi</button></div><strong>${money(i.final_line_price)}</strong></div>`).join('');
  subtotal.textContent=money(cart.total_price);
  const threshold=window.PSTheme.freeShipping||4900, pct=Math.min(100,(cart.total_price/threshold)*100); if(progress)progress.style.width=pct+'%';
  if(msg)msg.textContent=cart.total_price>=threshold?'Hai ottenuto la spedizione gratuita.':`Mancano ${money(threshold-cart.total_price)} alla spedizione gratuita.`;
}
function openDrawer(){const d=$('[data-cart-drawer]');if(d){d.classList.add('is-open');document.body.style.overflow='hidden';renderDrawer()}}
function closeDrawer(){const d=$('[data-cart-drawer]');if(d){d.classList.remove('is-open');document.body.style.overflow=''}}
document.addEventListener('click',async e=>{
  const open=e.target.closest('[data-open-cart]'); if(open){e.preventDefault();openDrawer()}
  if(e.target.closest('[data-close-cart]')) closeDrawer();
  const rem=e.target.closest('[data-remove-line]'); if(rem){await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:Number(rem.dataset.removeLine),quantity:0})});renderDrawer()}
});
document.addEventListener('submit',async e=>{
  const f=e.target.closest('[data-ajax-product-form]'); if(!f)return;
  e.preventDefault(); const b=f.querySelector('[type=submit]'), old=b?.textContent; if(b){b.disabled=true;b.textContent='Aggiungo…'}
  try{const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(f)});if(!r.ok)throw new Error();toast('Prodotto aggiunto al carrello');openDrawer()}catch(err){toast('Non è stato possibile aggiungere il prodotto')}finally{if(b){b.disabled=false;b.textContent=old}}
});
document.addEventListener('DOMContentLoaded',()=>{
  const popup=$('[data-welcome-popup]'); if(popup && !sessionStorage.getItem('psPopupSeen')){const delay=Number(popup.dataset.delay||12000);setTimeout(()=>{popup.classList.add('is-open');sessionStorage.setItem('psPopupSeen','1')},delay)}
  $$('[data-close-popup]').forEach(x=>x.addEventListener('click',()=>popup?.classList.remove('is-open')));
});

// Product page: un select per ogni opzione (Formato, Lavorazione, ecc.)
// invece di un unico elenco con tutte le combinazioni mischiate, più il
// selettore "acquisto singolo / abbonati e risparmia" quando il prodotto
// ha dei piani di abbonamento (selling plans) configurati su Shopify.
function initVariantPicker(root){
  const script=$('[data-product-json]',root); if(!script)return;
  let product; try{product=JSON.parse(script.textContent)}catch(e){return}
  const variants=product.variants||[];
  const selects=$$('[data-option-index]',root).sort((a,b)=>a.dataset.optionIndex-b.dataset.optionIndex);
  const hidden=$('[data-variant-id]',root), priceEl=$('[data-variant-price]',root), compareEl=$('[data-variant-compare]',root);
  const submitBtn=$('[data-product-submit]',root), unavailableMsg=$('[data-variant-unavailable]',root);

  const purchaseTypeWrap=$('[data-purchase-type]',root);
  const planPicker=$('[data-selling-plan-picker]',root);
  const planSelect=$('[data-selling-plan-select]',root);
  const planInput=$('[data-selling-plan-input]',root);
  let purchaseMode='onetime';

  const selection=()=>selects.length?selects.map(s=>s.value):[];
  const matchVariant=values=>{
    if(!variants.length)return null;
    if(!values.length)return variants[0];
    return variants.find(v=>{const opts=[v.option1,v.option2,v.option3];return values.every((val,i)=>opts[i]===val)});
  };
  function refreshOptionAvailability(){
    if(!selects.length)return;
    const current=selection();
    selects.forEach((select,i)=>{
      $$('option',select).forEach(opt=>{
        const test=current.slice(); test[i]=opt.value;
        opt.disabled=!matchVariant(test);
      });
    });
  }
  function planAllocation(variant){
    if(!variant||!planSelect||purchaseMode!=='subscription')return null;
    const planId=Number(planSelect.value);
    const list=variant.selling_plan_allocations||[];
    return list.find(a=>a.selling_plan_id===planId)||null;
  }
  function refresh(){
    refreshOptionAvailability();
    const variant=matchVariant(selection());
    if(variant){
      if(hidden)hidden.value=variant.id;
      const alloc=planAllocation(variant);
      if(priceEl)priceEl.textContent=money(alloc?alloc.price:variant.price);
      if(compareEl){
        const showCompare=alloc && alloc.compare_at_price && alloc.compare_at_price>alloc.price;
        if(showCompare){compareEl.hidden=false;compareEl.textContent=money(alloc.compare_at_price)}
        else compareEl.hidden=true;
      }
      if(planInput) planInput.value=purchaseMode==='subscription'&&planSelect?planSelect.value:'';
      if(unavailableMsg)unavailableMsg.hidden=true;
      if(submitBtn){
        submitBtn.disabled=!variant.available;
        const onLabel=purchaseMode==='subscription'?(submitBtn.dataset.labelSubscribe||submitBtn.dataset.labelAvailable):submitBtn.dataset.labelAvailable;
        submitBtn.textContent=variant.available?onLabel:submitBtn.dataset.labelSoldout;
      }
    }else{
      if(unavailableMsg)unavailableMsg.hidden=false;
      if(submitBtn){submitBtn.disabled=true;submitBtn.textContent=submitBtn.dataset.labelUnavailable}
    }
  }
  selects.forEach(s=>s.addEventListener('change',refresh));

  if(purchaseTypeWrap && planPicker){
    $$('[data-purchase-option]',purchaseTypeWrap).forEach(btn=>{
      btn.addEventListener('click',()=>{
        purchaseMode=btn.dataset.purchaseOption;
        $$('[data-purchase-option]',purchaseTypeWrap).forEach(b=>{
          const active=b===btn; b.classList.toggle('is-active',active); b.setAttribute('aria-pressed',active?'true':'false');
        });
        planPicker.hidden=purchaseMode!=='subscription';
        if(planInput) planInput.name=purchaseMode==='subscription'?'selling_plan':'';
        refresh();
      });
    });
    if(planSelect) planSelect.addEventListener('change',refresh);
  }

  refresh();
}

// Galleria prodotto: puntini sincronizzati con lo scroll orizzontale su mobile.
function initGalleryDots(gallery,dotsWrap){
  const items=$$('.ps-product-gallery__item',gallery);
  if(items.length<2)return;
  dotsWrap.innerHTML=items.map((_,i)=>`<button type="button" aria-label="Immagine ${i+1}" data-dot="${i}"></button>`).join('');
  const dots=$$('button',dotsWrap);
  const setActive=i=>dots.forEach((d,idx)=>d.classList.toggle('is-active',idx===i));
  setActive(0);
  dotsWrap.addEventListener('click',e=>{
    const btn=e.target.closest('[data-dot]'); if(!btn)return;
    items[Number(btn.dataset.dot)].scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'});
  });
  let ticking=false;
  gallery.addEventListener('scroll',()=>{
    if(ticking)return; ticking=true;
    requestAnimationFrame(()=>{
      const galleryMid=gallery.getBoundingClientRect().left+gallery.getBoundingClientRect().width/2;
      let closest=0,closestDist=Infinity;
      items.forEach((it,idx)=>{
        const r=it.getBoundingClientRect(), dist=Math.abs((r.left+r.width/2)-galleryMid);
        if(dist<closestDist){closestDist=dist;closest=idx}
      });
      setActive(closest); ticking=false;
    });
  },{passive:true});
}
document.addEventListener('DOMContentLoaded',()=>{
  $$('[data-product-options]').forEach(initVariantPicker);
  const gallery=$('[data-product-gallery]'), dotsWrap=$('[data-gallery-dots]');
  if(gallery&&dotsWrap) initGalleryDots(gallery,dotsWrap);
});
